import { isNumber } from 'lodash';
import { computed } from 'mobx';

import { transferStore } from '../../stores';

export const transferPrice = computed(() =>
  isNumber(transferStore.transferSettings?.price) ? transferStore.transferSettings?.price : null,
);
